@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../tooltip/style.scss' as *;
@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-icon-styles();
	.kol-badge {
		/* Visible with forced colors  */
		outline: transparent solid to-rem(1);
		display: flex;
		align-items: center;
		justify-content: space-between;

		.kol-badge__smart-button {
			.button {
				color: inherit;
			}
		}
	}
}
